import { Dispatch } from 'react';

import {
  Application,
  ApplicationPayload,
  createApplication,
  getApplications,
  payApplicationFee,
  updateApplication,
} from '../../services/apply';
import { captureException } from '../../services/sentry';
import { CustomError } from '../../utils/errors';
import {
  ActionInterface,
  dispatcher,
  generateActions,
} from '../../utils/redux';

export enum ApplyActions {
  createLeaseApplicationStart = '[APPLY]:CREATE_LEASE_APPLICATION:START',
  createLeaseApplicationSuccess = '[APPLY]:CREATE_LEASE_APPLICATION:SUCCESS',
  createLeaseApplicationError = '[APPLY]:CREATE_LEASE_APPLICATION:ERROR',
  getLeaseApplicationsStart = '[APPLY]:GET_LEASE_APPLICATIONS:START',
  getLeaseApplicationsSuccess = '[APPLY]:GET_LEASE_APPLICATIONS:SUCCESS',
  getLeaseApplicationsError = '[APPLY]:GET_LEASE_APPLICATIONS:ERROR',
  updateLeaseApplicationStart = '[APPLY]:UPDATE_LEASE_APPLICATION:START',
  updateLeaseApplicationSuccess = '[APPLY]:UPDATE_LEASE_APPLICATION:SUCCESS',
  updateLeaseApplicationError = '[APPLY]:UPDATE_LEASE_APPLICATION:ERROR',
  payApplicationFeeStart = '[APPLY]:UPDATE_LEASE_APPLICATION:START',
  payApplicationFeeSuccess = '[APPLY]:UPDATE_LEASE_APPLICATION:SUCCESS',
  payApplicationFeeError = '[APPLY]:UPDATE_LEASE_APPLICATION:ERROR',
}

const applyActionsMap: {
  [key: string]: ApplyActions;
} = ApplyActions as any;

export function DoCreateApplication(unitId: number) {
  const [start, success, error] = generateActions<ApplyActions, Application>(
    'createLeaseApplication',
    applyActionsMap
  );
  return async (
    d: Dispatch<ActionInterface<ApplyActions>>
  ): Promise<Application | CustomError> => {
    const dispatch = dispatcher(d as any);
    dispatch(start)();
    try {
      const response = await createApplication(unitId);
      dispatch(success)(response);
      return response;
    } catch (e) {
      const errors = captureException(e);
      dispatch(error)(errors.toString());
      return errors;
    }
  };
}

export function DoGetApplications(unitId: number) {
  const [start, success, error] = generateActions<ApplyActions, Application>(
    'getLeaseApplications',
    applyActionsMap
  );
  return async (
    d: Dispatch<ActionInterface<ApplyActions>>
  ): Promise<Application[] | CustomError> => {
    const dispatch = dispatcher(d as any);
    dispatch(start)();
    try {
      const response = await getApplications(unitId);
      dispatch(success)(response);
      return response;
    } catch (e) {
      const errors = captureException(e);
      dispatch(error)(errors.toString());
      return errors;
    }
  };
}

export function DoUpdateApplication(
  unitId: number,
  application: number,
  payload: ApplicationPayload
) {
  const [start, success, error] = generateActions<ApplyActions, Application>(
    'updateLeaseApplication',
    applyActionsMap
  );
  return async (
    d: Dispatch<ActionInterface<ApplyActions>>
  ): Promise<Application | CustomError> => {
    const dispatch = dispatcher(d as any);
    dispatch(start)();
    try {
      const response = await updateApplication(unitId, application, payload);
      dispatch(success)(response);
      return response;
    } catch (e) {
      const errors = captureException(e);
      dispatch(error)(errors.toString());
      return errors;
    }
  };
}

export function DoPayApplicationFee(
  unitId: number,
  application: number,
  tokenId: string
) {
  const [start, success, error] = generateActions<ApplyActions, Application>(
    'payApplicationFee',
    applyActionsMap
  );
  return async (
    d: Dispatch<ActionInterface<ApplyActions>>
  ): Promise<Application | CustomError> => {
    const dispatch = dispatcher(d as any);
    dispatch(start)();
    try {
      const response = await payApplicationFee(unitId, application, tokenId);
      dispatch(success)(response);
      return response;
    } catch (e) {
      const errors = captureException(e);
      dispatch(error)(errors.toString());
      return errors;
    }
  };
}
